import { computed, ComputedRef } from 'vue'

import { findSubParticipantWithStat } from '@collector/shared-domain'
import {
  BaseballSubParticipantStatId,
  SubParticipantPosition,
} from '@collector/sportsapi-client-legacy'
import { SubParticipant } from '@collector/sportsapi-types'
import { useInvertedSubParticipants } from '@desktop/views/Relation/composables'
import { IncidentPlayerOption } from '@desktop/views/Relation/types'

import { useInvertedIncidentPlayers } from '../../composables'
import { useEventDetailHalf } from './useEventDetailHalf'
import { usePitcherBatterOptions } from './usePitcherBatterOptions'

export function usePitcherOptions(): {
  options: ComputedRef<IncidentPlayerOption[]>
  currentPitcher: ComputedRef<SubParticipant | null>
} {
  // composables
  const { firstSubParticipants, secondSubParticipants } =
    useInvertedSubParticipants()
  const { firstTeamPlayersOptions, secondTeamPlayersOptions } =
    useInvertedIncidentPlayers()
  const { eventDetailHalfValue } = useEventDetailHalf()

  // data
  const isTopHalf = eventDetailHalfValue.value === 'top'

  // computed
  const pitchingSubparticipants = computed(() =>
    isTopHalf ? firstSubParticipants.value : secondSubParticipants.value,
  )

  const pitchingPlayersOptions = computed(() =>
    isTopHalf ? firstTeamPlayersOptions.value : secondTeamPlayersOptions.value,
  )

  const currentPitcher = computed(() =>
    findSubParticipantWithStat(
      pitchingSubparticipants.value,
      BaseballSubParticipantStatId.CurrentPitcher,
    ),
  )

  const options = usePitcherBatterOptions(
    pitchingPlayersOptions,
    currentPitcher,
    [SubParticipantPosition.Pitcher, SubParticipantPosition.Batter],
  )

  return {
    options,
    currentPitcher,
  }
}
